module.exports = __webpack_public_path__ + "static/media/dgd.017d2acb.svg";